import { useState } from "react";
import { Lock, LogIn } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";

// NOTE: This is a lightweight client-side gate for MVP. Server-side auth is P1.
const ADMIN_USERNAME = "Superadminciko";
const ADMIN_PASSWORD = "adminciko10";
const STORAGE_KEY = "ciko_admin_auth";

export function isAdminAuthed() {
    try {
        return localStorage.getItem(STORAGE_KEY) === "1";
    } catch {
        return false;
    }
}

export function signOutAdmin() {
    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch {
        /* noop */
    }
}

export default function AdminLogin({ onAuthed }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const submit = (e) => {
        e.preventDefault();
        if (username === ADMIN_USERNAME && password === ADMIN_PASSWORD) {
            try {
                localStorage.setItem(STORAGE_KEY, "1");
            } catch {
                /* noop */
            }
            setError("");
            onAuthed?.();
        } else {
            setError("Username atau password salah.");
        }
    };

    return (
        <div
            className="min-h-screen bg-[#0044FE] text-[#FAF9F6] grain flex items-center justify-center px-5"
            data-testid="admin-login"
        >
            <form
                onSubmit={submit}
                className="w-full max-w-md bg-[#001b6b] border-2 border-white/60 p-6 md:p-8"
                style={{ boxShadow: "10px 10px 0 #ED1C24" }}
            >
                <div className="flex items-center gap-3 mb-6">
                    <span
                        className="inline-flex items-center justify-center w-11 h-11 bg-[#ED1C24] border-2 border-white/70"
                        style={{ boxShadow: "3px 3px 0 #FAF9F6" }}
                    >
                        <Lock className="w-5 h-5" strokeWidth={2.5} />
                    </span>
                    <div>
                        <div className="font-mono-tight text-[10px] tracking-[0.28em] uppercase text-white/60">
                            CIKO · Control Room
                        </div>
                        <div className="font-display uppercase text-2xl">Admin Access</div>
                    </div>
                </div>

                <label className="block font-mono-tight text-[10px] uppercase tracking-widest text-white/70 mb-2">
                    Username
                </label>
                <Input
                    autoFocus
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    placeholder="Superadminciko"
                    className="bg-transparent border-white/40 text-white placeholder:text-white/40 rounded-none focus-visible:ring-[#ED1C24] focus-visible:ring-2"
                    data-testid="admin-username-input"
                />

                <label className="block font-mono-tight text-[10px] uppercase tracking-widest text-white/70 mb-2 mt-4">
                    Password
                </label>
                <Input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    placeholder="••••••••"
                    className="bg-transparent border-white/40 text-white placeholder:text-white/40 rounded-none focus-visible:ring-[#ED1C24] focus-visible:ring-2"
                    data-testid="admin-password-input"
                />

                {error && (
                    <div
                        className="mt-4 border border-red-400/40 bg-red-500/10 px-3 py-2 text-sm"
                        data-testid="admin-login-error"
                    >
                        {error}
                    </div>
                )}

                <Button
                    type="submit"
                    className="mt-6 w-full rounded-none bg-[#ED1C24] hover:bg-[#ff2a33] border-2 border-white/70 font-display uppercase tracking-wide"
                    data-testid="admin-login-submit"
                >
                    <LogIn className="w-4 h-4 mr-2" />
                    Login
                </Button>

                <div className="mt-6 text-[10px] font-mono-tight tracking-widest uppercase text-white/40">
                    Restricted area — CIKO Analytics
                </div>
            </form>
        </div>
    );
}
